import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Portfolio from '@/pages/Portfolio'
import Press from '@/pages/Press'
import Contact from '@/pages/Contact'
import Carousel from '@/components/Carousel'
import e404 from '@/components/e404'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
    	path: '/about',
    	name: 'About',
    	component: About
    },
    {
    	path: '/portfolio',
    	name: 'Portfolio',
    	component: Portfolio
    },
    {
    	path: '/press',
    	name: 'Press',
    	component: Press
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/carousel', 
        name: 'Carousel',
        component: Carousel
    },
    {
        path: '/404',
        name: 'Error 404',
        component: e404
    },
    {
        path: '*',
        redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js